import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { io, Socket } from "socket.io-client";
import { Helper } from "@utils/index";
import { APP_BASE_URL } from "@utils/request";

interface WebSocketContextType {
  socket: Socket | null;
  connected: boolean;
}

const WebSocketContext = createContext<WebSocketContextType>({
  socket: null,
  connected: false,
});

export const WebSocketProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [connected, setConnected] = useState(false);
  const user = Helper.getUser();
  const token = user?.token;
  // const socketURL =
  useEffect(() => {
    if (!token) return;

    const baseUrl = APP_BASE_URL || "";
    const isLocal =
      baseUrl.includes("localhost") || baseUrl.includes("127.0.0.1");
    let socketURL;
    if (isLocal) {
      socketURL = "ws://localhost:9001";
    } else {
      const url = new URL(baseUrl);

      socketURL = `${url.protocol === "https:" ? "wss:" : "ws:"}//${url.hostname}`;
    }

    const socketInstance = io(socketURL, {
      path: "/socket",
      auth: { token },
      transports: ["websocket", "polling"],
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
    });

    socketInstance.on("connect", () => {
      console.log("✅ WebSocket Connected");
      setConnected(true);
    });

    socketInstance.on("disconnect", () => {
      console.log("❌ WebSocket Disconnected");
      setConnected(false);
    });

    socketInstance.on("connect_error", (err) => {
      console.error("WebSocket Connection Error:", err);
      setConnected(false);
    });

    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
    };
  }, [token]);

  return (
    <WebSocketContext.Provider value={{ socket, connected }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = () => useContext(WebSocketContext);
